import Heading from '../components/Heading'
import Aside from '../components/Aside'
import dd from './dd'
import moment from 'moment'
import * as api from '@/api'
moment.defaultFormat = 'YYYY-MM-DD HH:mm:ss'
export default {
  install (Vue) {
    Vue.component('Aside', Aside)
    Vue.component('Heading', Heading)
    Vue.mixin({
      // mixins: [common]
      data () {
        return {
          w: 0,
          h: 0
        }
      },
      mounted () {

      },
      created () {
        this.query = this.$route?.query || {}
      },
      computed: {
        pathtype () {
          return this.query.id ? '编辑' : '新增'
        },
      },
      methods: {
        link(path) {
          this.$router.push(path)
        },
        uploadImage (img, type = 1) {
          return api
            .uploadImage({
              img,
              type,
            })
            .then((res) => {
              return res
            })
        },

        checkImg (url, type, w, h) {
          w = w || this.w
          h = h || this.h
          return new Promise((resolve) => {
            const img = new Image()
            img.src = url
            if (img.complete) {
              console.log(
                'from:complete  :width:' + img.width + ',height:' + img.height
              )
            } else {
              img.onload = async function () {
                let dataURL = ''
                const canvas = document.createElement('canvas')
                const width = img.width // 确保canvas的尺寸和图片一样
                const height = img.height
                canvas.width = width
                canvas.height = height
                canvas.getContext('2d').drawImage(img, 0, 0, width, height)
                dataURL = canvas.toDataURL('image/png')
                if ((w && width !== w) || (h && height !== h)) {
                  this.$message(
                    '图片宽高与要求不一致。' +
                      'width:' +
                      img.width +
                      ',height:' +
                      img.height
                  )
                }
                resolve(this.uploadImage(dataURL, type))
              }.bind(this)
            }
          })
        },
      },
    })

    Vue.directive('resize', {
      inserted (el, binding) {
        const resizeObserver = new ResizeObserver(entries => {
          for (let entry of entries) {
            binding.value(entry.contentRect)
          }
        })
        resizeObserver.observe(el)
      }
    })

    const fdate = date => date ? moment(date).format() : null
    Vue.prototype.fdate = fdate

    Vue.prototype.dateValue = arr => Array.isArray(arr) ? fdate(arr[0]) + '-' + fdate(arr[1]) : null

    Vue.prototype.isNumber = function (val) {
      return typeof val === 'number'
    }

    Vue.prototype.formatNum = function (num) {
      return Number(num).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
    }

    Vue.prototype.dd = dd
  }
}
